<template>
  <TableGradient
      icon-name="ticket-alt"
      :title="$t('container_support.listagem_etiquetas')"
      :text-empty="$t('container_support.etiqueta_nao_encontrada')"
      :fields="fields"
      :items="containers"
      :paginator="paginator"
      :loading="isLoading"
      @list="evt => $store.dispatch('container_support/listAll', evt)"
      table-data
  >
    <template v-slot:cell(status)="{ item: { status }}">
      <span :class="{
        'rounded-pill p-1 badge ': true,
        'badge-success': status === 'available',
        'badge-danger': status === 'canceled',
        'badge-warning': status === 'pending',
        'badge-primary': status === 'used'
      }"
            :title="getStatusString(status)"
            v-b-tooltip:hover
      >
        <i :class="{
          'fas ': true,
          'fa-check': status === 'available',
          'fa-ban': status === 'canceled',
          'fa-exclamation': status === 'pending',
          'fa-vial': status === 'used'
        }"/>
      </span>
    </template>
  </TableGradient>
</template>

<script>
import TableGradient from "@/templates/TableGradient";
import {mapActions, mapGetters} from 'vuex'

export default {
  name: "Index",
  components: {TableGradient},
  computed: {
    ...mapGetters({
      containers: 'container_support/all',
      paginator: 'container_support/pagination',
      store_isLoading: 'container_support/isLoading'
    }),
    isLoading() {
      return !(this.mounted && this.store_isLoading === false)
    }
  },
  data() {
    return {
      mounted: false,
      fields: [
        {key: 'identifier', label: this.$t('container_support.etiqueta'), sortable: true},
        {key: 'status', label: 'Status', sortable: true}
      ]
    }
  },
  methods: {
    ...mapActions([
      'container_support/listAll'
    ]),
    getStatusString(status) {
      switch (status) {
        case 'available':
          return this.$t('container_support.status.disponivel')
          break;
        case 'canceled':
          return this.$t('container_support.status.cancelada')
          break;
        case 'pending':
          return this.$t('container_support.status.pendente')
          break;
        case 'used':
          return this.$t('container_support.status.usada')
          break;
      }
    },
  },
  mounted() {
    this['container_support/listAll'](this.paginator)
    this.mounted = true
  }
}
</script>